import { gql } from "@apollo/client";

export const ME_QUERY = gql`
  query MeQuery {
    me {
      id
      name
      firstName
      lastName
      title
      fax
      displayName
      profile_pic
      phoneno
      mobile
      whatsAppUsername
      skypeUsername
      dob
      isActive
      isEmailVarified
      isUserVerified
      isDeleted
      isForceResetPassword
      email
      customerType
      roles {
        id
        key
      }
      isOnline
      userOrg {
        isVerified
        isDeleted
        isInvited
        isInvitedAndMerge
        isMergeOrganization
        isPrimary
        mergeOwnOrganization {
          id
        }
        id
        isIndividual
        organization {
          id
          name
          leagalName
          companyDescription
          TermsAndConditions
          productsOffered
          isDeleted
          phoneNo
          logo
          minBusinessYear
          yearsInBusiness
          commissionPercentage
          currentOffering
          pin
          email
          isSeller
          website
          specialtyServices
          fax
          serviceTypesOther
          servicesOfferedOther
          servicesOffered {
            id
            name
          }
          serviceTypes {
            id
            name
          }
          logisticPartner {
            id
            name
          }
          businessType {
            name
            id
          }
          companyType {
            name
            id
          }
          logisticsType {
            id
            name
          }
          locations {
            isPrimary
            street1
            street2
            countryName
            stateName
            cityName
            pincode
          }
        }
        roles {
          isInsideRole
          id
          key
        }
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
        companyDescription
        TermsAndConditions
        productsOffered
        logo
        fax
        minBusinessYear
        yearsInBusiness
        commissionPercentage
        specialtyServices
        currentOffering
        serviceTypesOther
        servicesOfferedOther
        businessType {
          name
          id
          isAuthorised
          isActive
        }
        companyType {
          name
          id
          isAuthorised
          isActive
        }
        otherBusinessType
        otherCompanyType
        orgSubscriptions {
          id
          feature
          status
          subscriptions {
            id
            title
            sellerFee
            feature
            name
            price
            key
          }
        }
        servicesOffered {
          id
          name
        }
        serviceTypes {
          id
          name
        }
        logisticPartner {
          id
          name
        }
        logisticsType {
          id
          name
        }
        locations {
          isPrimary
          id
          name
          type
          phoneNo
          lat
          long
          street1
          street2
          locationContact
          locationNotes
          countryName
          stateName
          cityName
          pincode
        }
      }
    }
  }
`;

export const USER_BY_ID = gql`
  query getUserById($userId: String!) {
    getUserById(userId: $userId) {
      id
      firstName
      lastName
      displayName
      name
      profile_pic
      phoneno
      dob
      isActive
      isEmailVarified
      isUserVerified
      isDeleted
      isForceResetPassword
      email
      roles {
        id
        key
      }
      userOrg {
        isVerified
        id
        isIndividual
        isDeleted
        organization {
          id
          name
          leagalName
          phoneNo
          pin
          email
          isSeller
          website
          logisticsType {
            id
            name
          }
          logisticPartner {
            id
            name
          }
          locations {
            street1
            street2
            countryName
            stateName
            cityName
            pincode
          }
        }
        roles {
          id
          key
        }
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
        locations {
          street1
          street2
          countryName
          stateName
          cityName
          pincode
        }
      }
    }
  }
`;

export const GET_ASSET_DETAIL_BY_ID = gql`
  query getAssetDetailById($assetId: String!) {
    getAssetDetailById(assetId: $assetId) {
      id
      enNumber
      seller {
        id
        displayName
      }
      assetManagers {
        id
        displayName
      }
      negotiation {
        status {
          key
          name
        }
        createdBy {
          displayName
          id
        }
      }
      ownership {
        id
        ownershipType
        lender
        payOffAmount
        comment
        ownershipSignature
        termsAndConditions
        ownershipDate
      }
      category {
        id
        name
      }
      subCategory {
        id
        name
      }
      location {
        id
        name
        lat
        long
        stateName
        cityName
      }
      make {
        id
        name
      }
      model {
        id
        name
      }
      createdBy {
        id
        displayName
        currentOrganization {
          offerThreshold
        }
      }
      serialNo
      hour
      assetNo
      year
      sellingPrice
      minPrice
      isDeleted
      priceHide
      features
      manufactured
      millage
      vin
      assignee {
        id
        displayName
        email
        phoneno
        profile_pic
        isOnline
      }
      seller {
        id
        displayName
        email
        phoneno
        profile_pic
        isVerified
      }
      description
      assetAdditionalInfo
      assetMedias {
        media
        isPublish
        imageName
        isPrimary
        featuredMediaFlag
        id
      }
      assetCategoryClass {
        id
        name
        key
      }
      guaranteedLoanFree
      maxPriceReduced
      boosterApply
      packagedAsset
      sellerInspection
      virtualInspection
      thirdPartyInspection
      enNumber
      status {
        id
        name
        key
        status
      }
      organization {
        id
        name
        orgSubscriptions {
          id
          isDeleted
          feature
          status
          boosterCount
          orgSubscriptionAddonBooster {
            quantity
            boosterAmount
            availableQuantity
            stripeInvoicePaid
          }
          subscriptions {
            id
            key
            name
            title
            feature
          }
        }
      }
    }
  }
`;

export const LIST_DASHBOARD_ENTITIES = gql`
  {
    getDashboardCounts {
      totalAssets
      totalAssetsUnderNegotiations
      totalAssignedAssets
    }
  }
`;

export const USER_NOTIFICATION = gql`
  subscription($recievedId: String!) {
    assetNotification(recievedId: $recievedId) {
      id
      message
    }
  }
`;

export const GET_ROLES_PERMISSION = gql`
  query getRoles($roles: [String!]!) {
    getAllPermissionsByRoleKeys(roleKeys: $roles) {
      name
      status
      actions
      parent
    }
  }
`;

export const GET_GSETIING = gql`
  query getTimerList($skip: Float!, $take: Float!) {
    getAllGlobalSettings(skip: $skip, take: $take) {
      count
      result {
        id
        title
        key
        format
        status
        createdAt
        updatedAt
        description
      }
    }
  }
`;

export const GET_ASSET_ID_BY_ENNUMBER = gql`
  query getAssetIdByEnNumber($enNumber: String!) {
    getAssetIdByEnNumber(enNumber: $enNumber) {
      id
    }
  }
`;

export const GET_COUNTRIES = gql`
  {
    getCountryList {
      id
      name
    }
  }
`;
